<template>
  <div class="default-title">
      <el-form label-width="120px" :model="form" class="list-top-margin production-progress">
        <el-row>
          <el-col :span="8">
            <el-form-item label="工艺路线编号">
              <el-input size="small" v-model="form.technologyCode" placeholder="请输入" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="工艺路线名称" >
              <el-input size="small" v-model="form.technologyName" placeholder="请输入" clearable></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="4" class="text-align-right">
            <el-form-item label-width="20px">
              <el-button size="mini" type="primary" icon="el-icon-search" @click="search">查询</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-table ref="tableData" size="small" :data="listData"
      highlight-current-row @current-change="handleCurrentChange"
      v-loading="loading" max-height="400px" stripe border
      element-loading-text="拼命加载中" :header-cell-style="_headerStyle"
      style="width: 100%;"  @selection-change="handleSelectionChange"
      row-key="_id">
        <el-table-column width="60">
          <template slot-scope="scope">
            <el-radio v-model="radio" :label="scope.row.technologyCode" @click.native="radioChange(scope.row)">{{radioLabel}}</el-radio>
          </template>
        </el-table-column>
        <el-table-column align="left" type="index" width="50" label="序号"></el-table-column>
        <el-table-column prop="technologyCode" label="工艺路线编号">
          <template slot-scope="scope">
              <el-tooltip :content="scope.row.technologyCode" placement="top">
                <span class="txt-overflow">{{scope.row.technologyCode}}</span>
              </el-tooltip>
            </template>
        </el-table-column>
        <el-table-column prop="processName" label="工艺路线名称">
          <template slot-scope="scope">
              <el-tooltip :content="scope.row.technologyName" placement="top">
                <span class="txt-overflow">{{scope.row.technologyName}}</span>
              </el-tooltip>
            </template>
        </el-table-column>
        <el-table-column prop="nongoodIdList" label="工序/工艺路线列表">
          <template slot-scope="scope">
              <el-tooltip :content="formatProcess(scope.row.processList)" placement="top">
                <span class="txt-overflow">{{formatProcess(scope.row.processList)}}</span>
              </el-tooltip>
            </template>
        </el-table-column>
      </el-table>
       <!-- 分页组件 -->
      <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
      <div slot="footer" class="text-align-center" style="position: relative;">
        <!-- <div class="select-count-content">已选{{selectCount}}项</div> -->
        <el-button size="small" @click="cancel">取 消</el-button>
        <el-button size="small" type="primary" class="title" @click="save">保 存</el-button>
      </div>
  </div>
</template>
<script>
import { technologyGetList} from '@/api/basicData'
import Pagination from '@/components/Pagination'
export default {
  components: {
    Pagination,
  },
  data() {
    return {
      buttonSize:'small',
      form:{
        processCode:''
      },
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      loading:false,
      selectCount:0,
      userData:{},
      radio:'',
      radioLabel:'',
      seleted:{},
    }
  },
  created() {
    var userData = window.localStorage.getItem('userdata')
    if(userData){
      this.userData = JSON.parse(userData)
    }
    this.getdata()
  },
  methods:{
    search(){
      this.pageparm.currentPage =1;
      this.pageparm.pageSize = 10;
      this.getdata()
    },
    getdata() {
      this.loading = true
      var params = {
        condition: {
          factoryId: this.userData.factoryId,
          technologyCode: this.form.technologyCode,
          technologyName: this.form.technologyName,
        },
        currentPage: this.pageparm.currentPage,
        pageSize: this.pageparm.pageSize,
      }
      technologyGetList(params).then(res => {
        if(res.code == 200){
          this.pageparm.total = res.data.total || 0;
          this.listData = res.data.list;
        }else{
          this.pageparm.total = 0;
          this.$message.error('查询失败！')
        }
        this.loading = false
      })
      .catch(err => {
        this.loading = false
        this.$message.error(err)
      })
    },
    cancel(){
      this.$emit('done',{type:'cancel'})
    },
    save(){
      this.seleted['type'] = 'technology';
      this.$emit('done',{type:'save',data:this.seleted})
    },
    callFather(parm) {
      this.pageparm.currentPage = parm.currentPage
      this.pageparm.pageSize = parm.pageSize
      this.getdata()
    },
    handleSelectionChange(){
      this.selectCount = this.$refs.tableData.selection.length
    },
    formatProcess(options){
      if(options && options.length!=0){
        var res = options.map(function(item){
          if(item.type == 'process'){
            return item.processName
          }else{
            return item.technologyName
          }
        })
        if(res && res.length!=0){
          return res.join(',')
        }
      }
    },
    radioChange(row){
      this.seleted = JSON.parse(JSON.stringify(row)) ;
    },
    handleCurrentChange(row){
      this.radio = row.technologyCode
      this.seleted = JSON.parse(JSON.stringify(row)) ;
    },
  }
}
</script>
<style>
.production-progress .el-input-group__append,
.production-progress .el-input-group__prepend{
  color: #fff;
  background-color: #409EFF!important;
  border-radius: 0 4px 4px 0;
}
.select-count-content{
  position: absolute;
  left: 0;
  top: -45px;
  font-size: 12px;
}
.el-form-item {
  margin-bottom: 20px;
}
</style>




// WEBPACK FOOTER //
// src/views/order/dialogManage/choose-technology.vue